<div class="flex-column animated fadeIn" style="border-radius: 8px; overflow: hidden; border: 1px solid #dee2e6; font-family: 'Courier New', Courier, monospace; height: 520px;">
	<div class="flex-row" style="flex: 1; overflow: hidden;">

		<!--Left sidebar: Docs / History / Explorer toggles-->
		<div class="flex-column align-items-center" style="width: 48px; background: #f8f9fa; border-right: 1px solid #dee2e6; padding: 10px 0; gap: 4px; flex-shrink: 0;">
			<button tooltip="Docs"
					style="width: 34px; height: 34px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.15s;"
					[style.background]="activePanel === 'docs' ? '#e9ecef' : 'transparent'"
					[style.color]="activePanel === 'docs' ? '#212529' : '#6c757d'"
					(click)="setPanel('docs')">
				<i class="far fa-book" style="font-size: 14px;"></i>
			</button>
			<button tooltip="History"
					style="width: 34px; height: 34px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.15s;"
					[style.background]="activePanel === 'history' ? '#e9ecef' : 'transparent'"
					[style.color]="activePanel === 'history' ? '#212529' : '#6c757d'"
					(click)="setPanel('history')">
				<i class="far fa-history" style="font-size: 14px;"></i>
			</button>
			<button tooltip="Explorer"
					style="width: 34px; height: 34px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.15s;"
					[style.background]="activePanel === 'explorer' ? '#e9ecef' : 'transparent'"
					[style.color]="activePanel === 'explorer' ? '#212529' : '#6c757d'"
					(click)="setPanel('explorer')">
				<i class="far fa-compass" style="font-size: 14px;"></i>
			</button>
		</div>

		<!--Left panel content (Docs / History / Explorer)-->
		<div *ngIf="activePanel" class="flex-column animated fadeIn" style="width: 260px; background: white; border-right: 1px solid #dee2e6; overflow-y: auto; flex-shrink: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;">

			<!--=== DOCS ===-->
			<ng-container *ngIf="activePanel === 'docs'">
				<div class="flex-row align-items-center" style="padding: 12px 16px; border-bottom: 1px solid #dee2e6;">
					<span style="color: #212529; font-size: 15px; font-weight: 600;">Docs</span>
				</div>
				<div *ngIf="docsLoading" class="flex-row align-items-center" style="padding: 20px 16px; gap: 8px; color: #6c757d; font-size: 13px;">
					<i class="far fa-spinner fa-spin"></i>
					<span>Loading schema...</span>
				</div>
				<div *ngIf="!docsLoading && !schemaData" style="padding: 16px; color: #6c757d; font-size: 13px; line-height: 1.6;">
					Could not load schema.
				</div>
				<div *ngIf="!docsLoading && schemaData && !selectedType" class="flex-column" style="padding: 12px 0;">
					<p style="padding: 0 16px 12px; color: #6c757d; font-size: 12px; line-height: 1.6; margin: 0;">
						A GraphQL schema provides a root type for each kind of operation.
					</p>
					<div class="flex-column">
						<div class="flex-row align-items-center" style="padding: 6px 16px; cursor: pointer; gap: 6px;"
							 (click)="docsRootCollapsed = !docsRootCollapsed">
							<i [ngClass]="docsRootCollapsed ? 'far fa-chevron-right' : 'far fa-chevron-down'"
							   style="font-size: 10px; color: #adb5bd; width: 10px;"></i>
							<span style="color: #495057; font-size: 13px; font-weight: 500;">Root Types</span>
						</div>
						<div *ngIf="!docsRootCollapsed" class="flex-column" style="padding: 2px 0 8px 32px; gap: 4px;">
							<div *ngIf="schemaData.queryType" class="flex-row gap-1" style="font-size: 13px;">
								<span style="color: #d73a49;">query</span>
								<span style="color: #6c757d;">:</span>
								<span style="color: #0550ae; cursor: pointer;" (click)="selectType(schemaData.queryType.name)">{{schemaData.queryType.name}}</span>
							</div>
							<div *ngIf="schemaData.mutationType" class="flex-row gap-1" style="font-size: 13px;">
								<span style="color: #d73a49;">mutation</span>
								<span style="color: #6c757d;">:</span>
								<span style="color: #0550ae; cursor: pointer;" (click)="selectType(schemaData.mutationType.name)">{{schemaData.mutationType.name}}</span>
							</div>
							<div *ngIf="schemaData.subscriptionType" class="flex-row gap-1" style="font-size: 13px;">
								<span style="color: #d73a49;">subscription</span>
								<span style="color: #6c757d;">:</span>
								<span style="color: #0550ae; cursor: pointer;" (click)="selectType(schemaData.subscriptionType.name)">{{schemaData.subscriptionType.name}}</span>
							</div>
						</div>
					</div>
					<div class="flex-column">
						<div class="flex-row align-items-center" style="padding: 6px 16px; cursor: pointer; gap: 6px;"
							 (click)="docsTypesCollapsed = !docsTypesCollapsed">
							<i [ngClass]="docsTypesCollapsed ? 'far fa-chevron-right' : 'far fa-chevron-down'"
							   style="font-size: 10px; color: #adb5bd; width: 10px;"></i>
							<span style="color: #495057; font-size: 13px; font-weight: 500;">All Schema Types</span>
						</div>
						<div *ngIf="!docsTypesCollapsed" class="flex-column" style="padding: 2px 0 8px 32px; gap: 3px;">
                            <span *ngFor="let type of schemaTypes"
								  style="color: #0550ae; font-size: 13px; cursor: pointer; padding: 1px 0;"
								  (click)="selectType(type.name)">
                                {{type.name}}
                            </span>
						</div>
					</div>
				</div>
				<div *ngIf="!docsLoading && selectedType" class="flex-column" style="padding: 12px 0;">
					<div class="flex-row align-items-center" style="padding: 4px 16px 12px; gap: 6px; cursor: pointer;" (click)="backToDocs()">
						<i class="far fa-arrow-left" style="font-size: 11px; color: #6c757d;"></i>
						<span style="color: #6c757d; font-size: 12px;">Back</span>
					</div>
					<div class="flex-column" style="padding: 0 16px 12px; gap: 4px;">
						<span style="color: #0550ae; font-size: 15px; font-weight: 600;">{{selectedType.name}}</span>
						<span style="color: #6c757d; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">{{selectedType.kind}}</span>
						<span *ngIf="selectedType.description" style="color: #6c757d; font-size: 12px; line-height: 1.6; margin-top: 4px;">{{selectedType.description}}</span>
					</div>
					<div *ngIf="selectedType.fields?.length" class="flex-column" style="border-top: 1px solid #dee2e6; padding-top: 8px;">
						<span style="color: #6c757d; font-size: 11px; font-weight: 500; padding: 4px 16px 8px; text-transform: uppercase; letter-spacing: 0.5px;">Fields</span>
						<div *ngFor="let field of selectedType.fields" class="flex-column" style="padding: 6px 16px; gap: 2px; border-bottom: 1px solid #f1f3f5;">
							<div class="flex-row align-items-baseline gap-1" style="font-size: 13px; flex-wrap: wrap;">
								<span style="color: #005cc5;">{{field.name}}</span>
								<span style="color: #6c757d;">:</span>
								<span style="color: #8250df;">{{formatTypeRef(field.type)}}</span>
							</div>
							<span *ngIf="field.description" style="color: #6c757d; font-size: 11px; line-height: 1.5;">{{field.description}}</span>
						</div>
					</div>
					<div *ngIf="!selectedType.fields?.length" style="padding: 8px 16px; color: #6c757d; font-size: 12px;">
						No fields (scalar type)
					</div>
				</div>
			</ng-container>

			<!--=== HISTORY ===-->
			<ng-container *ngIf="activePanel === 'history'">
				<div class="flex-row align-items-center" style="padding: 12px 16px; border-bottom: 1px solid #dee2e6;">
					<span style="color: #212529; font-size: 15px; font-weight: 600;">History</span>
				</div>
				<div *ngIf="!queryHistory.length" style="padding: 16px; color: #6c757d; font-size: 13px; line-height: 1.6;">
					Executed queries will appear here.
				</div>
				<div *ngFor="let item of queryHistory"
					 class="flex-column"
					 style="padding: 10px 16px; border-bottom: 1px solid #f1f3f5; cursor: pointer; gap: 3px;"
					 (click)="loadFromHistory(item)">
                    <span style="color: #005cc5; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 228px;">
                        {{item.query.split('\n')[0]}}
                    </span>
					<span style="color: #adb5bd; font-size: 11px;">{{item.timestamp | date:'MM/dd HH:mm'}}</span>
				</div>
			</ng-container>

			<!--=== EXPLORER ===-->
			<ng-container *ngIf="activePanel === 'explorer'">
				<div class="flex-row align-items-center" style="padding: 12px 16px; border-bottom: 1px solid #dee2e6;">
					<span style="color: #212529; font-size: 15px; font-weight: 600;">Explorer</span>
				</div>
				<div *ngIf="docsLoading" class="flex-row align-items-center" style="padding: 20px 16px; gap: 8px; color: #6c757d; font-size: 13px;">
					<i class="far fa-spinner fa-spin"></i>
					<span>Loading schema...</span>
				</div>
				<div *ngIf="!docsLoading && explorerInitialized" class="flex-column" style="padding: 8px 0; font-family: 'Courier New', Courier, monospace; font-size: 13px;">
					<div class="flex-row align-items-center" style="padding: 4px 12px 8px; gap: 5px;">
						<span style="color: #d73a49;">query</span>
						<span style="color: #6f42c1;">{{explorerOperationName}}</span>
						<span style="color: #6e7781;">{{ '{' }}</span>
					</div>
					<div *ngFor="let node of explorerTree" class="flex-column">
						<ng-container *ngIf="node.hasChildren">
							<div class="flex-row align-items-center"
								 style="padding: 3px 12px; gap: 6px; cursor: pointer; user-select: none;"
								 (click)="onExplorerParentClick(node)">
								<i [ngClass]="node.expanded ? 'fas fa-caret-down' : 'fas fa-caret-right'"
								   style="font-size: 10px; color: #adb5bd; width: 10px; flex-shrink: 0;"></i>
								<span [style.color]="node.expanded ? '#24292e' : '#6e7781'">{{node.name}}</span>
							</div>
							<div *ngIf="node.expanded" class="flex-column" style="padding-bottom: 2px;">
								<div *ngFor="let child of node.children"
									 class="flex-row align-items-center"
									 style="padding: 3px 12px 3px 28px; gap: 8px; cursor: pointer; user-select: none;"
									 (click)="onExplorerChildClick(child)">
									<div style="width: 15px; height: 15px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center;"
										 [style.background]="child.selected ? '#0969da' : 'transparent'"
										 [style.border]="child.selected ? 'none' : '1.5px solid #d0d7de'">
										<i *ngIf="child.selected" class="far fa-check" style="color: white; font-size: 8px;"></i>
									</div>
									<span [style.color]="child.selected ? '#24292e' : '#6e7781'">{{child.name}}</span>
									<span style="color: #adb5bd; font-size: 11px; margin-left: auto;">{{child.typeName}}</span>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="!node.hasChildren">
							<div class="flex-row align-items-center"
								 style="padding: 3px 12px; gap: 8px; cursor: pointer; user-select: none;"
								 (click)="onExplorerLeafClick(node)">
								<div style="width: 15px; height: 15px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; margin-left: 14px;"
									 [style.background]="node.selected ? '#0969da' : 'transparent'"
									 [style.border]="node.selected ? 'none' : '1.5px solid #d0d7de'">
									<i *ngIf="node.selected" class="far fa-check" style="color: white; font-size: 8px;"></i>
								</div>
								<span [style.color]="node.selected ? '#24292e' : '#6e7781'">{{node.name}}</span>
							</div>
						</ng-container>
					</div>
					<div style="padding: 4px 12px; color: #6e7781;">{{ '}' }}</div>
				</div>
				<div *ngIf="!docsLoading && !explorerInitialized" style="padding: 16px; color: #6c757d; font-size: 13px;">
					No schema loaded.
				</div>
			</ng-container>

		</div>

		<!--Query editor with syntax highlight overlay-->
		<div style="flex: 1; background: #f6f8fa; position: relative; overflow: hidden; border-right: 1px solid #dee2e6;">
			<div #hlBackdrop
				 style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; padding: 16px; font-size: 13px; line-height: 1.7; white-space: pre-wrap; word-wrap: break-word; pointer-events: none; overflow: hidden; font-family: inherit;"
				 [innerHTML]="highlightedQuery | SafeHtml">
			</div>
			<span *ngIf="!queryInput"
				  style="position: absolute; top: 16px; left: 16px; color: #adb5bd; font-size: 13px; pointer-events: none;">
                Enter GraphQL query...
            </span>
			<textarea #textareaEl
					  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 16px; background: transparent; color: transparent; caret-color: #24292e; border: none; outline: none; font-size: 13px; line-height: 1.7; font-family: inherit; resize: none; overflow: auto; white-space: pre-wrap; word-wrap: break-word; box-sizing: border-box; z-index: 1;"
					  [(ngModel)]="queryInput"
					  (ngModelChange)="onQueryChange($event)"
					  (scroll)="syncScroll($event, hlBackdrop)"
					  (keydown)="onKeyDown($event, textareaEl)"
					  (keyup)="onKeyUp($event, textareaEl)"
					  (click)="updateAutocomplete(textareaEl)"
					  (blur)="onEditorBlur()"
					  [disabled]="queryInProcess"
					  spellcheck="false">
            </textarea>
		</div>

		<!--Autocomplete dropdown-->
		<div *ngIf="showAutocomplete"
			 style="position: fixed; z-index: 9999; background: white; border: 1px solid #d0d7de; border-radius: 6px; overflow: hidden; min-width: 220px; max-height: 220px; overflow-y: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.15);"
			 [style.top]="acPosition.top + 'px'"
			 [style.left]="acPosition.left + 'px'"
			 (mousedown)="$event.preventDefault()">
			<div *ngFor="let item of autocompleteItems; let i = index"
				 style="padding: 6px 12px; cursor: pointer; display: flex; align-items: baseline; gap: 8px; font-family: 'Courier New', Courier, monospace;"
				 [style.background]="i === acSelectedIdx ? '#f6f8fa' : 'white'"
				 (mouseenter)="acSelectedIdx = i"
				 (click)="applyAutocomplete(item, textareaEl)">
				<span style="color: #005cc5; font-size: 13px;">{{item.name}}</span>
				<span style="color: #adb5bd; font-size: 11px; margin-left: auto;">{{item.type}}</span>
			</div>
		</div>

		<!--Right buttons: Play + Prettify + Expand + Copy-->
		<div class="flex-column gap-3" style="background: #f8f9fa; padding: 12px 8px; align-items: center; border-left: 1px solid #dee2e6; border-right: 1px solid #dee2e6;">
			<button style="width: 42px; height: 42px; border-radius: 50%; background: #f38ba8; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: opacity 0.2s;"
					[style.opacity]="(queryInProcess || !queryInput) ? '0.5' : '1'"
					[disabled]="queryInProcess || !queryInput"
					(click)="executeQuery()">
				<i *ngIf="!queryInProcess" class="far fa-play" style="color: white; margin-left: 2px; font-size: 13px;"></i>
				<i *ngIf="queryInProcess" class="far fa-spinner fa-spin" style="color: white; font-size: 13px;"></i>
			</button>
			<button tooltip="Prettify query"
					style="width: 32px; height: 32px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; background: transparent;"
					[style.color]="queryInput ? '#6c757d' : '#dee2e6'"
					[disabled]="!queryInput"
					(click)="prettifyQuery()">
				<i class="fa fa-magic" style="font-size: 13px;"></i>
			</button>
			<button tooltip="Copy query"
					style="width: 32px; height: 32px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; background: transparent;"
					[style.color]="queryInput ? '#6c757d' : '#dee2e6'"
					[disabled]="!queryInput"
					(click)="copyQuery()">
				<i class="far fa-copy" style="font-size: 13px;"></i>
			</button>
			<button tooltip="Copy URL request"
					style="width: 32px; height: 32px; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; background: transparent;"
					[style.color]="queryInput ? '#6c757d' : '#dee2e6'"
					[disabled]="!queryInput"
					(click)="copyUrlRequest()">
				<i class="far fa-link" style="font-size: 13px;"></i>
			</button>
		</div>

		<!--Right: Response panel-->
		<div class="flex-column" style="flex: 1; background: white; overflow: auto; padding: 12px 8px;">
			<div *ngIf="queryInProcess" class="flex-row align-items-center justify-content-center" style="flex: 1;">
				<loader></loader>
			</div>
			<ng-container *ngIf="!queryInProcess">
            <span *ngIf="!jsonNodes.length" style="color: #adb5bd; font-size: 13px; padding: 4px 8px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;">
                Response will appear here...
            </span>
				<ng-container *ngFor="let node of jsonNodes">
					<div *ngIf="isVisible(node)"
						 style="display: flex; align-items: baseline; line-height: 1.9; font-size: 13px; white-space: nowrap; user-select: text;"
						 [style.padding-left]="(node.depth * 16 + 4) + 'px'">

						<ng-container *ngIf="node.type === 'object-open' || node.type === 'array-open'">
                        <span style="cursor: pointer; width: 14px; flex-shrink: 0; color: #adb5bd;" (click)="toggleNode(node)">
                            <i [ngClass]="collapsedIds.has(node.id) ? 'fas fa-caret-right' : 'fas fa-caret-down'" style="font-size: 10px;"></i>
                        </span>
							<span *ngIf="node.key" style="color: #005cc5;">"{{node.key}}"</span>
							<span *ngIf="node.key" style="color: #24292e;">:&nbsp;</span>
							<span style="color: #24292e;">{{node.openChar}}</span>
							<ng-container *ngIf="collapsedIds.has(node.id)">
								<span style="color: #adb5bd;">&nbsp;...&nbsp;</span>
								<span style="color: #24292e;">{{node.closeChar}}</span>
							</ng-container>
						</ng-container>

						<ng-container *ngIf="node.type === 'object-close' || node.type === 'array-close'">
							<span style="width: 14px; flex-shrink: 0;"></span>
							<span style="color: #24292e;">{{node.closeChar}}</span>
						</ng-container>

						<ng-container *ngIf="node.type === 'value'">
							<span style="width: 14px; flex-shrink: 0;"></span>
							<span *ngIf="node.key" style="color: #005cc5;">"{{node.key}}"</span>
							<span *ngIf="node.key" style="color: #24292e;">:&nbsp;</span>
							<span [style.color]="getValueColor(node.valueType)">{{formatValue(node)}}</span>
						</ng-container>

					</div>
				</ng-container>
			</ng-container>
		</div>

	</div>
</div>
